export type RiskCatalogKind =
  | 'modo_falla'
  | 'efecto'
  | 'area_gestion'
  | 'control'
  | 'situacion_op';

export interface RiskCatalogItem {
  id: string;
  kind: RiskCatalogKind;
  label: string;
  sortOrder: number;
  active: boolean;
}

export const CATALOG_KIND_LABEL: Record<RiskCatalogKind, string> = {
  modo_falla: 'Modo de falla',
  efecto: 'Efecto potencial',
  area_gestion: 'Área de gestión',
  control: 'Control',
  situacion_op: 'Situación operacional',
};
